<template>
  <div class="audit-report">
    <ReportHead :report="report" />

    <ReportCategories :report="report" />
  </div>
</template>

<script>
import ReportHead from './report_head'
import ReportCategories from './report_categories'

export default {
  components: { ReportHead, ReportCategories },
  props: {
    report: { type: Object, required: true }
  }
}
</script>
